export default __webpack_public_path__ + "static/media/r1.01b1fce7.png";